import jQuery from 'jquery';
let $ = jQuery;
import __extends from "LIBS/extend.js";

import "LIBS/jquery.showhtml.js";
// Desktop/Mobile split... Use Globally available HSN.Modal
//import "HSNDIR/Modal.js";

/**
* class HSN.ProfileImageUploadModal
*
* Encapsulates the functionality of a modal dialog that uploads a customer profile image.
**/
HSN.ProfileImageUploadModal = (function (parent) {
    __extends(ProfileImageUploadModal, parent);
        
    function ProfileImageUploadModal() {
        /** new HSN.ProfileImageUploadModal() **/
        var modal = ProfileImageUploadModal.__super__.constructor.call(this);

        this.Close.off();//remove existing handler, have our own
        this.accountService = HSN.Instance()._getAccountService();
            
        eventHandlers(this);

        return modal;
    }

    function eventHandlers(modal) {
        var scope = modal;
        $(modal.Close).on('click', function () {
            closeModal(modal);
        });
        $(modal.Content).on('click', '#submit', function () {
            HSN.SetWait();
            scope.accountService.UploadProfileImage(new FormData($('#image-upload')[0]), {
                callback: function (data) {
                    if (data.success) {
                        HSN.RemoveWait();
                        window.location.href = '/myaccount/update?tab=profile'
                    }
                    else {
                        HSN.RemoveWait();
                        HSN.AddErrorTreatment($('#image-upload'), data);
                    }
                },
                errorCallback: function () {
                    HSN.RemoveWait();
                    alert('Unfortunately there was an error, please try again.');
                },
                scope: this
            });
            return false;
        });
        $(modal.Content).on('click', '#cancel', function () {
            closeModal(modal);
            return false;
        });
    }

    function closeModal(modal) {
        modal.Hide();
    }

    /**
    * HSN.ProfileImageUploadModal#Show() -> void
    * - productId (string): The identifier for the product to load the information into the modal for.
    *
    * Display the modal and load in the information for the given product identifier.
    **/
    ProfileImageUploadModal.prototype._show = function (config) {
        var scope = this;

        $.ajax(
            '/myaccount/profile-image-upload',
            {
                context: this,
                dataType: 'html',
                data: {},
                success: function (data, status, xhr) {
                    var __scope = this;
                    __scope.Root.removeClass('loading');

                    this.Content.showHtml
                    (
                        data,
                        0,
                        function () {
                            __scope.Center();
                            __scope.Content.animate({ opacity: 1 });
                            $(__scope.Root).find('#browse').focus();
                        },
                        function () {
                            //__scope.Center();
                        }
                    );

                },
                error: function (xhr, status, error) {
                    alert("Unfortunately there was an error attempting to load the content, please try again.");
                    $('#modal-mask').remove();
                }
            }
        );
    };
    return ProfileImageUploadModal;
})(HSN.Modal);



// WEBPACK FOOTER //
// ./assets/js/HSN/Modals/MyAccount/ProfileImageUploadModal.js